import './consent-code.scss';

// move the inert template code into the live DOM; scripts need to be re-created
// so the browser executes them (cloned/inserted scripts never run on their own)
const injectCode = ($content) => {
    if (!$content || $content.dataset.injected === 'true') {
        return;
    }

    const $template = $content.querySelector('template[data-consent-code="code"]');

    if (!$template) {
        return;
    }

    const fragment = $template.content.cloneNode(true);

    fragment.querySelectorAll('script').forEach(($old) => {
        const $script = document.createElement('script');

        [...$old.attributes].forEach((attr) => {
            // drop OneTrust "text/plain" gating so the script actually executes
            if (attr.name === 'type' && attr.value === 'text/plain') {
                return;
            }

            $script.setAttribute(attr.name, attr.value);
        });

        $script.async = false; // preserve execution order for external src scripts
        $script.textContent = $old.textContent;
        $old.replaceWith($script);
    });

    $content.appendChild(fragment);
    $content.dataset.injected = 'true';
};

const grant = ($consentCode) => {
    const $content = $consentCode.querySelector('[data-consent-code="content"]');
    const $placeholder = $consentCode.querySelector('[data-restriction="wall"]');

    injectCode($content);
    $placeholder?.remove();
    $content?.classList.remove('has--restriction');
};

const restrict = ($consentCode, category) => {
    const $content = $consentCode.querySelector('[data-consent-code="content"]');
    const $placeholder = $consentCode.querySelector('[data-restriction="wall"]');
    const $button = $consentCode.querySelector('[data-restriction="remove"]');

    if ($button) {
        $button.addEventListener('click', () => {
            if (category !== '' && typeof OneTrust.UpdateConsent !== 'undefined') { // eslint-disable-line
                OneTrust.UpdateConsent('Category', `${category}:1`); // eslint-disable-line
            } else {
                OneTrust.ToggleInfoDisplay(); // eslint-disable-line
            }
        });
    }

    $placeholder?.classList.add('is--shown');
    $content?.classList.add('has--restriction');
};

export { injectCode, grant, restrict };

window.addEventListener('content.loaded', (e) => {
    const { $context } = e.detail;

    if (!$context) {
        return;
    }

    const $$consentCodes = $context.querySelectorAll('[data-consent-code="root"]');

    if ($$consentCodes.length === 0) {
        return;
    }

    const waitForConsent = setInterval(() => {
        if (typeof OneTrust === 'undefined') { // eslint-disable-line
            return;
        }

        clearInterval(waitForConsent);

        $$consentCodes.forEach(($consentCode) => {
            const category = $consentCode.dataset.consentCodeCategory || '';
            const isGranted = () => category !== '' && OnetrustActiveGroups.indexOf(category) !== -1; // eslint-disable-line

            if (isGranted()) {
                grant($consentCode);
            } else {
                restrict($consentCode, category);
            }

            OneTrust.OnConsentChanged(() => { // eslint-disable-line
                if (isGranted()) {
                    grant($consentCode);
                }
            });
        });
    }, 300);
});
